import Siema from 'siema';

const onCarouselInit = () => {
  /*
  Placeholder: oncarouselInit: Runs immediately after initialization
  */
};

const onCarouselChange = () => {
  /*
  Placeholder : oncarouselChange: Runs after slide change
  */
};

export const appendElementArray = (carousel, elementArray) => {
  for (const element of elementArray) {
    carousel.append(element);
  }
};

export const jumpToSlide = (carousel, jumpIndex) => {
  carousel.goTo(jumpIndex);
};

export const dynamicAppendElements = (carousel, elementArray = [], sliceSize = 1) => {
  const slicedArray = elementArray.slice(0, sliceSize);
  for (const elm of slicedArray) {
    carousel.append(elm);
  }
  elementArray.splice(0, slicedArray.length);
  return elementArray;
};

export const gotoNextSlide = (carousel, callback, totalSlides, step = 1, loop = false) => {
  const { perPage } = carousel;
  const currentSlide = carousel.currentSlide + 1;
  if (!(totalSlides - currentSlide < perPage && !loop)) {
    carousel.next(step, callback(currentSlide, totalSlides - currentSlide === perPage && !loop));
  } else {
    callback(carousel.currentSlide, !loop);
  }
  return carousel.currentSlide;
};

export const gotoPreviousSlide = (carousel, callback, step = 1, loop = false) => {
  const { currentSlide } = carousel;
  if (currentSlide === 0 && !loop) {
    callback(carousel.currentSlide, true);
  } else {
    carousel.prev(step, callback(carousel.currentSlide - 1, currentSlide === 1 && !loop));
  }
};

export const destroyCarousel = (casousel, restoreMarkup = false) => {
  casousel.destroy(restoreMarkup);
};

export const buildCarousel = (
  selector,
  carouselConfig,
  onInit = onCarouselInit,
  onChange = onCarouselChange,
  ...params
) => {
  const carousel = new Siema({
    selector,
    duration: carouselConfig.duration || 600,
    easing: carouselConfig.easing || 'ease-out',
    perPage: carouselConfig.perPage || {
      100: 2.5,
      800: 3.5,
    },
    startIndex: carouselConfig.startIndex || 0,
    draggable: carouselConfig.draggable || true,
    multipleDrag: carouselConfig.multipleDrag || false,
    threshold: carouselConfig.threshold || 20,
    loop: carouselConfig.loop || false,
    rtl: false,
    onInit: () => onInit(...params),
    onChange: () => onChange(...params),
  });
  return carousel;
};
